import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import CtaLink from './CtaLink'
import { CtaBlockIconSmall, CtaBlockIconLarge } from './../Icons'

import { object } from 'prop-types'
import * as Styled from './styles/CtaBlock.styles'

const SimpleCta = ({ data, bottomPaddingAdjustment }) => {
  const isHeaderEmpty = !data.header?.text || data.header.text.trim() === ''

  // Check if body_text is empty or if it contains only empty paragraphs
  const isBodyEmpty =
    !data.body_text?.richText ||
    data.body_text.richText.length === 0 ||
    (data.body_text.richText.length === 1 &&
      data.body_text.richText[0].type === 'paragraph' &&
      (!data.body_text.richText[0].text ||
        data.body_text.richText[0].text.trim() === ''))

  const bothEmpty = isHeaderEmpty && isBodyEmpty

  const noPaddingStyles = `
    padding-top: 0;
    padding-bottom: 0;
  `

  return (
    <Styled.LeftAlignedCtaBlock
      bottomPaddingAdjustment={bottomPaddingAdjustment}
    >
      <Styled.LeftAlignedTextContainer>
        {!isHeaderEmpty && <Styled.Title>{data.header.text}</Styled.Title>}
        {!isBodyEmpty && (
          <Styled.Body>
            <PrismicRichText field={data.body_text.richText} />
          </Styled.Body>
        )}
        {data.cta_link_text && (
          <CtaLink
            text={data.cta_link_text ? data.cta_link_text : ''}
            link={data.cta_link}
            additionalStyles={
              bothEmpty ? noPaddingStyles : Styled.leftAlignedCtaStyles
            }
          />
        )}
      </Styled.LeftAlignedTextContainer>
    </Styled.LeftAlignedCtaBlock>
  )
}

const CenteredCtaWithIcon = ({ data, bottomPaddingAdjustment }) => (
  <Styled.CtaBlock bottomPaddingAdjustment={bottomPaddingAdjustment}>
    <Styled.TextContainer>
      <Styled.Title>{data.header?.text ?? ''}</Styled.Title>
      <Styled.Body>
        {data.body_text && <PrismicRichText field={data.body_text.richText} />}
      </Styled.Body>
      {data.cta_link_text && (
        <CtaLink
          text={data.cta_link_text ? data.cta_link_text : ''}
          link={data.cta_link}
          additionalStyles={Styled.additionalCtaStyles}
        />
      )}
    </Styled.TextContainer>
    <Styled.IconSmallContainer>
      <CtaBlockIconSmall />
    </Styled.IconSmallContainer>
    <Styled.IconLargeContainer>
      <CtaBlockIconLarge />
    </Styled.IconLargeContainer>
  </Styled.CtaBlock>
)

const CtaBlock = ({ data, bottomPaddingAdjustment }) => {
  if (data.layout_style === 'Simple CTA - Left-aligned Text') {
    return (
      <SimpleCta
        data={data}
        bottomPaddingAdjustment={bottomPaddingAdjustment}
      />
    )
  } else {
    return (
      <CenteredCtaWithIcon
        data={data}
        bottomPaddingAdjustment={bottomPaddingAdjustment}
      />
    )
  }
}

CtaBlock.propTypes = {
  data: object,
}

export default CtaBlock
